<div class="layout-wrapper" [ngClass]="{'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple,
		'layout-static': isStatic(),
		'layout-overlay': isOverlay(),
		'layout-overlay-active': overlayMenuActive && isOverlay(),
		'layout-horizontal': isHorizontal(),
		'layout-static-active': !staticMenuDesktopInactive && isStatic(),
		'layout-mobile-active': staticMenuMobileActive,
		'layout-rtl': app.isRTL,
		'layout-rightpanel-active': rightPanelActive}" [class]="'layout-menu-'+ app.menuTheme+ ' layout-topbar-'+ app.topbarTheme">

	<app-rightpanel></app-rightpanel>
	<app-user-menubutton></app-user-menubutton>

	<div class="menu-wrapper" (click)="onMenuClick($event)">
		<div class="layout-menu-container">
			<app-user-menu></app-user-menu>
		</div>
	</div>
	
	<div class="layout-main">
		<app-user-topbar></app-user-topbar>

		<div class="layout-content px-2">
			<router-outlet></router-outlet>
		</div>

		<app-common-footer></app-common-footer>
	</div>

	<div *ngIf="staticMenuMobileActive" class="layout-mask modal-in"></div>

</div>
